<div class="content">
  <div class="card">
    <div class="d-flex align-items-center mb-2">
      <h1 *ngIf="title" class="card-title mr-2">{{ title }}</h1>
      <span *ngIf="notice" class="card-badge">{{ notice }}</span>
    </div>
    <div class="card-simple">
      <div
        *ngFor="let item of body; let isLast = last"
        class="card-simple-content"
      >
        <div
          *ngIf="item.icon"
          class="card-icon"
          [ngClass]="
            item.iconColor === 'positive'
              ? 'c-positive'
              : item.iconColor === 'danger'
              ? 'c-danger'
              : item.iconColor === 'alert'
              ? 'c-alert'
              : item.iconColor === 'dark'
              ? 'c-dark'
              : item.iconColor === 'info'
              ? 'c-info'
              : 'c-highlight-a'
          "
        >
          <img [src]="'../../../../assets/svg/' + item.icon + '.svg'" />
        </div>
        <div
          class="card-description"
          [ngStyle]="{ 'margin-right': isLast ? '0' : '' }"
        >
          <span>{{ item.description }}</span>
          <span
            [ngStyle]="{
              color:
                item.description === 'Bloqueado' ||
                item.description === 'bloqueado'
                  ? '#FC5346'
                  : ''
            }"
          >
            <ng-container
              *ngIf="isNumber(item.value); else notNumber"
            >
              {{ item.value | currency : "BRL" }}
            </ng-container>
            <ng-template #notNumber>
              {{ item.value }}
            </ng-template>
          </span>
        </div>
        <div *ngIf="!isLast" class="card-divider"></div>
      </div>
    </div>
    <button *ngIf="button" (click)="action()">
      <span>{{ button }}</span>
      <img [src]="'../../../../assets/svg/arrow-carrousel-right.svg'" />
    </button>
  </div>
</div>
